import { SelectBox } from "devextreme-react";
import { uqActions } from "@/redux/uq/uq-slice";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { CalculateGrid } from "@/redux/uq/uq-actions";
import { useAppSelector } from "@/hooks/useAppSelector";
import ScrollView from "devextreme/ui/scroll_view";
import NumberBoxWrapper from "@/components/NumberBoxWrapper";
import { UNIQUE_POSSIBILITIES } from "@/constants/constants";

export default function Assumptions() {
  const { gridSet, settings } = useAppSelector((state) => state.uq);
  const { household } = useAppSelector((state) => state.household);
  const dispatch = useAppDispatch();

  async function onUpdateHandler(value: any) {
    if (gridSet) dispatch(uqActions.setReload(true));

    dispatch(
      uqActions.setSettings({
        ...settings,
        ...value,
      })
    );

    await dispatch(CalculateGrid(0, null));

    dispatch(uqActions.setIsModified(true));
    if (gridSet) {
      const sv = document.getElementById("household-scrollview") as HTMLElement;
      const scroll = ScrollView.getInstance(sv) as any;

      setTimeout(() => {
        dispatch(uqActions.setReload(false));
        setTimeout(() => {
          if (scroll) {
            const h = scroll.scrollHeight();
            scroll.scrollTo(h);
          }
        }, 100);
      }, 300);
    }
  }

  return (
    <div className={`flex items-center gap-8 text-neutral-100`}>
      <div className="flex flex-col gap-6">
        <span className="block text-lg font-medium">Calculation Assumptions</span>
        <div className="flex gap-4">
          <NumberBoxWrapper
            value={settings?.ror}
            width={114}
            format={"#.#%"}
            step={0.01}
            stylingMode="outlined"
            label="Rate of Return"
            onValueChange={(value) => {
              onUpdateHandler({
                ror: value,
              });
            }}
          />
          <NumberBoxWrapper
            value={settings?.inflation}
            width={114}
            format={"#.#%"}
            step={0.01}
            stylingMode="outlined"
            label="Inflation Rate"
            onValueChange={(value) => {
              onUpdateHandler({
                inflation: value,
              });
            }}
          />
          <NumberBoxWrapper
            value={settings?.cola}
            width={114}
            format={"#.#%"}
            label="Social Security"
            stylingMode="outlined"
            step={0.01}
            onValueChange={(value) => {
              onUpdateHandler({
                cola: value,
              });
            }}
          />
        </div>
      </div>

      {settings.person1?.showSS ? (
        <div className="flex flex-col gap-6">
          <span className="block w-full self-end break-words text-lg font-medium">
            Social Security - {household?.primaryContact?.preferredFirstName}
          </span>
          <div className="flex items-center gap-4">
            <SelectBox
              width={108}
              value={settings?.person1?.beginAt || UNIQUE_POSSIBILITIES.MinAge}
              items={UNIQUE_POSSIBILITIES.SocialSecurityAgeList}
              label="Begin at Age"
              onValueChange={(value) => {
                onUpdateHandler({
                  person1: {
                    ...settings.person1,
                    amount: settings?.person1.amount,
                    beginAt: value,
                  },
                });
              }}
              stylingMode="outlined"
            />
            <NumberBoxWrapper
              format={"$ #,##0.##"}
              value={settings?.person1?.amount}
              width={144}
              stylingMode="outlined"
              label="Amount"
              onValueChange={(value) => {
                onUpdateHandler({
                  person1: {
                    ...settings.person1,
                    amount: value,
                    beginAt: settings?.person1.beginAt,
                  },
                });
              }}
            />
          </div>
        </div>
      ) : null}

      {!household?.isSingle && settings?.person2?.showSS ? (
        <div className="flex flex-col gap-6">
          <span className="block w-full self-end break-words text-lg font-medium">
            Social Security - {household?.secondaryContact?.preferredFirstName}
          </span>

          <div className="flex items-center gap-4">
            <SelectBox
              width={108}
              value={settings?.person2?.beginAt || UNIQUE_POSSIBILITIES.MinAge}
              items={UNIQUE_POSSIBILITIES.SocialSecurityAgeList}
              stylingMode="outlined"
              label="Begin at Age"
              onValueChange={(value) => {
                onUpdateHandler({
                  person2: {
                    ...settings.person2,
                    amount: settings?.person2?.amount ?? 0,
                    beginAt: value,
                  },
                });
              }}
            />
            <NumberBoxWrapper
              stylingMode="outlined"
              width={144}
              format={"$ #,##0.##"}
              label="Amount"
              value={settings?.person2?.amount ?? undefined}
              onValueChange={(value) => {
                onUpdateHandler({
                  person2: {
                    ...settings.person2,
                    beginAt: settings?.person2?.beginAt ?? 63,
                    amount: value,
                  },
                });
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
